export enum BidView {
  STANDARD,
  GRID
}
